import { render, staticRenderFns } from "./edit-blobs-dialog.vue?vue&type=template&id=451a5c12&scoped=true&"
import script from "./edit-blobs-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-blobs-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451a5c12",
  null
  
)

export default component.exports